import React, { Component } from 'react';
import * as encryptUtils from "./encryptDecryptUtils";
import * as loggingUtils from "./utils/loggingUtils";
import { previousLivestreamData } from './PreviousLivestreamData';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';

class PreviousLivestreams extends Component {
  constructor(props) {
    super(props);
    this.slideLeft = this.slideLeft.bind(this);
    this.slideRight = this.slideRight.bind(this);
  }

  slideLeft() {
    var slider = document.getElementById('slider')
    slider.scrollLeft = slider.scrollLeft - 500
  }

  slideRight() {
    var slider = document.getElementById('slider')
    slider.scrollLeft = slider.scrollLeft + 500
  }

  render() {
    return (
      <div className="w-full">
        <div className="ml-10 font-bold text-zinc-900 dark:text-white text-4xl font-semibold">
          RECENT LIVESTREAMS
        </div>
        <div className="relative flex mt-8 items-center">
          <MdChevronLeft className="opacity-50 cursor-pointer hover:opacity-100 text-zinc-600 dark:text-white" onClick={this.slideLeft} size={40} />
          <div id="slider" className="w-full h-full overflow-x-scroll scroll whitespace-nowrap scroll-smooth scrollbar-hide">
            {previousLivestreamData.map((item) => (
              <div className="h-80 inline-block bg-gradient-to-br from-custom-black via-zinc-800 shadow-2xl to-custom-black rounded-xl mx-2">
                <img
                  className="w-[400px] h-[230px] object-cover inline-block cursor-pointer rounded-xl"
                  src={item.image}
                  onClick={()=> {
                    window.open(window.location.origin + item.itemRoute, "_self")
                  }}
                  alt='/'
                />
                <div className="flex items-center h-[90px]">
                  <img
                    className="ml-4 w-8 h-8 rounded-full"
                    src={item.creatorImage}
                    onClick={()=> {
                      window.open(window.location.origin + item.itemRoute, "_self")
                    }}
                  />
                  <div>
                    <div className="ml-4 cursor-pointer text-white flex font-semibold"
                      onClick={()=> {
                        window.open(window.location.origin + item.itemRoute, "_self")
                      }}
                    >
                      {item.itemName}
                    </div>
                    <div className="ml-4 cursor-pointer hover:underline text-zinc-400 text-sm flex font-semibold"
                      onClick={()=> {
                        window.open(window.location.origin + item.itemRoute, "_self")
                      }}
                    >
                      {item.creatorName}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <MdChevronRight className="opacity-50 cursor-pointer hover:opacity-100 text-white" onClick={this.slideRight} size={40} />
        </div>
      </div>
    );
  }
}

export default PreviousLivestreams;
